
import ClassNames from 'classnames';
import ControlGroup from './control-group.jsx';
import ObjectAssign from 'object-assign';
import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  autocapitalize: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  hasError: PropTypes.bool,
  help: PropTypes.string,
  inputClasses: PropTypes.object,
  label: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  checked: PropTypes.bool,
  autocomplete: PropTypes.string,
  maxlength: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};
const defaultProps = {
  type: 'text',
  autocapitalize: 'off',
};

class TextControl extends React.Component {
  focus() {

    return this.input.focus();
  }

  value() {

    return this.input.value;
  }

  render() {

    const inputClasses = ClassNames(ObjectAssign({
      'form-control': true,
    }, this.props.inputClasses));

    return (
      <ControlGroup
        hasError={this.props.hasError}
        label={this.props.label}
        labelFor={this.props.id}
        help={this.props.help}>

        <input
          ref={(c) => (this.input = c)}
          type={this.props.type}
          autoCapitalize={this.props.autocapitalize}
          autoComplete={this.props.autocomplete}
          maxLength={this.props.maxlength}
          className={inputClasses}
          name={this.props.name}
          id={this.props.id}
          placeholder={this.props.placeholder}
          value={this.props.value}
          disabled={this.props.disabled ? 'disabled' : undefined}
          required={!!this.props.required}
          onChange={this.props.onChange}
          checked={this.props.checked}
        />
      </ControlGroup>
    );
  }
}

TextControl.propTypes = propTypes;
TextControl.defaultProps = defaultProps;


export default TextControl;



// WEBPACK FOOTER //
// ./client/components/form/text-control.jsx